import { Box, Typography, IconButton, Dialog, DialogTitle, DialogContent, Paper, MenuItem, Divider, Grid, Button } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";



interface NetLockProps {
  open: boolean;
  onClose: () => void;
}

export const NetLock: React.FC<NetLockProps> = ({ open,onClose }) => {
    const { handleSubmit, control, register } = useForm();

  
  
  const onSubmit = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#388e3c", color: "#fff" }}>
       Net Locks
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#fff",
          }}
        >
          <WSIcons.CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid
          sx={{
            height: "20rem",
            backgroundColor: "#e0e0e0",
            border: "1px solid #ccc",
            display: "flex",
            mt:2
          }}
        ></Grid>
      </DialogContent>

      <Grid
        item
        mt={2}
        sx={{
          backgroundColor: "#333",
          padding: 2,
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <WSIcons.GTranslateIcon fontSize="medium" sx={{ color: "#fff" }} />
          </Grid>

          <Grid item>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button variant="contained" color="success">
                Finish
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};
